export default __webpack_public_path__ + "static/salebg-dcad0a8eb70ccbfb9ed59d5685941427.png";